import nlnAxios from "../../../api/nlnAxios";


//Create Resources

const createResourceTag = async (formData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
            
    }
}

    const response = await nlnAxios.post("/library/resources/tags", formData);
    return response.data;
}

//Edit Resources
const editResourceTag = async (resourceTagData, token) => {

    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`
    //     }
    // }

    const response = await nlnAxios.patch(`/library/resources/tags/${resourceTagData.resourceTagId}`, resourceTagData);
    return response.data

}

//Get Resources

const getResourceTag = async (token) => {

    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`
    //     }
    // }

    const response = await nlnAxios.get("/library/resources/tags");

    return response.data;
}


//Delete resource category 
const deleteResourceTag = async (resourceTagId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/resources/tags/" + resourceTagId);

    return response.data;
}



const resourcetagService = {
    createResourceTag,
    editResourceTag,
    getResourceTag,
    deleteResourceTag
}

export default resourcetagService;